export default __webpack_public_path__ + "static/media/boy.a25e39d3.png";